<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <Wxts :wxtsList="wxtsList" />

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"
      @onChange="onSearchItemChange">
      <!-- 表头设置控件 -->
      <template #right>
        <TableHeadSelect :config="formCtrlRight" :options="formCtrlRight.options" :inputValue="defaultTh"
          @onChange="onTableSelect" />
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :showTotal="true"
      :getTotal="getTotal" @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange"
      @onSizeChange="onSizeChange">
      <!-- <template #month="params">
        {{ params.params.month ? Number(params.params.month.split('-')[1]) + '月' : "-" }}
      </template> -->
    </Table>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

export default {
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'monther',
      getListUrl: 'fxrec',
      breadcrumb: [
        { name: "财务管理", path: `` },
        { name: "月度分析表", path: `` },
      ],
      wxtsList: [
        {
          name: '营业成本：营业成本=司机工资+押运员工资+车队长工资+出车费用+固定费用+维保费用+附加费用+亏吨金额+利润奖金-运单补差-合同补差'
        },
      ],
      formInline: { year: undefined },
      formCtrl: [
        {
          label: "年份：",
          placeholder: "请选择年份",
          keyName: "year",
          type: 'year',
        },
      ],
      cols: [
        { keyName: "month", label: "月份", minwidth: 100 },
        { keyName: "freight", label: "运费总额", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "tb_freight", label: "同比", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "hb_freight", label: "环比", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "cost", label: "营业成本", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "tb_cost", label: "同比", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "hb_cost", label: "环比", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "profit", label: "净利总额", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "tb_profit", label: "同比", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "hb_profit", label: "环比", align: 'right', className: 'pr30', minwidth: 120 },
      ],
      getTotalProperty: [
        'freight',
        // 'tb_freight',
        // 'hb_freight',
        'cost',
        // 'tb_cost',
        // 'hb_cost',
        'profit',
        // 'tb_profit',
        // 'hb_profit'
      ],
      baseParams: ['year'],
    };
  },
  methods: {
    dataObjHandler(v) {
      const o = {}
      for (const key in v) {
        if (Object.hasOwnProperty.call(v, key)) {
          if (key.includes('tb') || key.includes('hb')) {
            o[key] = v[key] + '%';
          } else {
            o[key] = v[key];
          }
        }
      }
      return o
    },
  },
  mounted() {
    // console.log({ ...this.formInline })
    this.formInline.year = this.DATE_OBJ.y
    // console.log({ ...this.formInline })
    this.getList()
  },
};
</script>
